import React from 'react';
import { Clipboard, CheckCircle2, XCircle } from 'lucide-react';
import { ActionProposalMessage } from '../types/space';
interface ActionCardProps {
  message: ActionProposalMessage;
  onConfirm: (id: string) => void;
  onSkip: (id: string) => void;
}
export function ActionCard({
  message,
  onConfirm,
  onSkip
}: ActionCardProps) {
  const isPending = message.status === 'pending';
  const isConfirmed = message.status === 'confirmed';
  const isSkipped = message.status === 'skipped';
  return <div className="w-full my-6 pl-11 pr-4" data-id="element-1">
      <div className={`
        relative w-full bg-white rounded-lg shadow-sm border-l-4 p-5 transition-all
        ${isPending ? 'border-l-blue-500 border-y border-r border-gray-200' : ''}
        ${isConfirmed ? 'border-l-green-500 border-y border-r border-green-100 bg-green-50/30' : ''}
        ${isSkipped ? 'border-l-gray-300 border-y border-r border-gray-100 opacity-60' : ''}
      `} data-id="element-2">
        {/* Header */}
        <div className="flex items-center justify-between mb-3" data-id="element-3">
          <div className="flex items-center space-x-2" data-id="element-4">
            <Clipboard className={`h-4 w-4 ${isPending ? 'text-blue-500' : 'text-gray-400'}`} data-id="element-5" />
            <span className="text-xs font-bold uppercase tracking-wider text-gray-500" data-id="element-6">
              Proposed Action
            </span>
          </div>
          {isConfirmed && <span className="flex items-center text-xs font-medium text-green-600 bg-green-100 px-2 py-0.5 rounded-full" data-id="element-7">
              <CheckCircle2 className="h-3 w-3 mr-1" data-id="element-8" />
              Approved
            </span>}
          {isSkipped && <span className="flex items-center text-xs font-medium text-gray-500 bg-gray-100 px-2 py-0.5 rounded-full" data-id="element-9">
              <XCircle className="h-3 w-3 mr-1" data-id="element-10" />
              Skipped
            </span>}
        </div>

        {/* Content */}
        <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-11">
          {message.title}
        </h3>

        <ul className="space-y-2 mb-4" data-id="element-12">
          {message.steps.map((step, idx) => <li key={idx} className="flex items-start text-sm text-gray-600" data-id="element-13">
              <span className="h-1.5 w-1.5 rounded-full bg-gray-300 mt-1.5 mr-2.5 flex-shrink-0" data-id="element-14" />
              {step}
            </li>)}
        </ul>

        <div className="flex items-center justify-between mt-4 pt-4 border-t border-gray-100" data-id="element-15">
          <span className="text-xs text-gray-400 font-medium" data-id="element-16">
            {message.scope}
          </span>

          {isPending && <div className="flex items-center space-x-3" data-id="element-17">
              <button onClick={() => onSkip(message.id)} className="text-sm font-medium text-gray-500 hover:text-gray-700 px-3 py-1.5" data-id="element-18">
                Skip
              </button>
              <button className="text-sm font-medium text-gray-700 hover:bg-gray-100 px-3 py-1.5 rounded-md transition-colors" data-id="element-19">
                Edit plan
              </button>
              <button onClick={() => onConfirm(message.id)} className="text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 px-4 py-1.5 rounded-md shadow-sm transition-colors" data-id="element-20">
                Let's go
              </button>
            </div>}
        </div>
      </div>
    </div>;
}